import type { InstrumentInstrumentType } from "Infrastructure/ApiZfp/Schema/instrumentInstrumentType";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const useInstrumentTypeLabel = () => {
  const { t } = useResource();

  return (instrumentType: InstrumentInstrumentType | null | undefined, fallback = "—") =>
    instrumentType ? t(Resources.AnalysisDetail.GoalsFulfillment.Nsure.InstrumentType[instrumentType]) : fallback;
};
